module.exports = __webpack_public_path__ + "img/swift-2022.d2485204.svg";